<!-- Brewery Skeleton Loader -->
<div *ngIf="isLoadingBrewery">
  <div class="bg-[var(--tertiary)] py-12">
    <div class="container-padding mx-auto max-w-screen-desktop">
      <app-skeleton dimensions="h-10 w-1/2 mx-auto"></app-skeleton>
    </div>
  </div>

  <div class="bg-[var(--light-grey)]">
    <div class="container-padding mx-auto max-w-screen-desktop">
      <div class="grid mobile-m:grid-cols-2 grid-cols-1 mobile-m:gap-12 mobile-m:gap-4 py-12">
        <div class="col-span-1 flex flex-col">
          <div class="flex gap-8">
            <!-- Logo skeleton -->
            <app-skeleton dimensions="h-28 w-28 rounded"></app-skeleton>
            <div class="flex flex-col gap-4">
              <!-- Category skeleton -->
              <app-skeleton dimensions="h-4 w-40"></app-skeleton>
              <!-- Social links skeleton -->
              <div class="flex gap-3 items-center">
                <app-skeleton dimensions="h-4 w-16"></app-skeleton>
                <app-skeleton dimensions="h-8 w-8 rounded-full"></app-skeleton>
                <app-skeleton dimensions="h-8 w-8 rounded-full"></app-skeleton>
                <app-skeleton dimensions="h-8 w-8 rounded-full"></app-skeleton>
              </div>
            </div>
          </div>
  
          <div class="mt-6">
            <!-- Description title skeleton -->
            <app-skeleton dimensions="h-8 w-40 mb-4"></app-skeleton>
            <!-- Description content skeleton -->
            <app-skeleton dimensions="h-4 w-full mb-2"></app-skeleton>
            <app-skeleton dimensions="h-4 w-full mb-2"></app-skeleton>
            <app-skeleton dimensions="h-4 w-3/4"></app-skeleton>
          </div>
        </div>

        <div class="col-span-1">
          <!-- Branches title skeleton -->
          <app-skeleton dimensions="h-8 w-40 mb-4"></app-skeleton>
          <!-- Map skeleton -->
          <app-skeleton dimensions="tablet:h-[450px] mobile-m:h-[370px] mobile:h-[320px] h-[270px] w-full rounded-2xl"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Brewery Content -->
<div class="" *ngIf="!isLoadingBrewery && brewery">
  <div class="bg-[var(--tertiary)] py-12">
    <div class="container-padding mx-auto max-w-screen-desktop">
      <h1 class="uppercase text-[var(--beige)] text-[40px]/[40px] font-normal text-center">{{brewery.name}}</h1>
    </div>
  </div>

  <div class="bg-[var(--light-grey)]">
    <div class="container-padding mx-auto max-w-screen-desktop">
      <div class="grid mobile-m:grid-cols-2 grid-cols-1 mobile-m:gap-12 mobile-m:gap-4 py-12">
        <div class="col-span-1 flex flex-col">
          <div class="flex gap-8">
            <img class="h-28 w-28 object-cover rounded" [src]="brewery.logoUrl" [alt]="'Drinkhopping - '+brewery.name">
            <div class="flex flex-col gap-4">
              <div class="" *ngIf="brewery.breweryType">
                <p class="text-[14px]/[14px] font-semibold uppercase">Categoria: {{brewery.breweryType.name}}</p>
              </div>
              <div class="flex gap-3 items-center">
                <p class="text-[14px]/[14px] font-semibold uppercase">Social: </p>
                <a *ngIf="brewery.instagramLink" [href]="'https://www.instagram.com/' + brewery.instagramLink"
                  target="_blank" rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]"
                  aria-label="Instagram">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faInstagram" size="xl"></fa-icon>
                </a>
                <a *ngIf="brewery.tiktokLink" [href]="'https://www.tiktok.com/' + brewery.tiktokLink" target="_blank"
                  rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="TikTok">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faTiktok" size="xl"></fa-icon>
                </a>
                <a *ngIf="brewery.facebookLink" [href]="'https://www.facebook.com/' + brewery.facebookLink"
                  target="_blank" rel="noopener noreferrer" class="text-[var(--black)] hover:text-[var(--secondary)]"
                  aria-label="Facebook">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faFacebook" size="xl"></fa-icon>
                </a>
                <a *ngIf="brewery.webLink" [href]="brewery.webLink" target="_blank" rel="noopener noreferrer"
                  class="text-[var(--black)] hover:text-[var(--secondary)]" aria-label="Facebook">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faGlobe" size="xl"></fa-icon>
                </a>
              </div>
            </div>
          </div>
  
          <div class="">
            <h3 class="uppercase text-[var(--dark-orange)] font-normal text-[25px]/[71px]">{{ 'brewery.description' | translate }}</h3>
            <p [style.white-space]="'pre-line'"
              class="text-[16px]/[24px] font-normal font-[var(--black)] leading-relaxed">
              {{brewery.description}}
            </p>
          </div>
        </div>


        <div class="col-span-1">
          <h3 class="uppercase text-[var(--dark-orange)] font-normal text-[25px]/[71px]">{{ 'brewery.branches' | translate }}</h3>
          <div class="w-full tablet:h-[450px] mobile-m:h-[370px] mobile:h-[320px] h-[270px] rounded-2xl overflow-hidden border-2 border-[var(--grey)] shadow-sm" style="z-index: 0;">
            <app-map *ngIf="brewery.branches" [branches]="brewery.branches" [mapHeight]="'100%'"
              class="w-full h-full block"></app-map>
          </div>

          <!-- Schedules per branch -->
          <div *ngIf="brewery.branches && brewery.branches.length > 0" class="mt-6 flex flex-col gap-1">
            <div *ngFor="let branch of brewery.branches">
              <div *ngIf="branchHasSchedules(branch)">
                <!-- Branch toggle -->
                <button class="w-full flex items-center justify-between py-3 text-left group"
                        (click)="toggleSchedule(branch.id)"
                        [attr.aria-expanded]="expandedScheduleBranchId === branch.id">
                  <div class="flex items-center gap-2">
                    <fa-icon [icon]="faClock" class="text-[var(--dark-orange)] text-xs"></fa-icon>
                    <span class="text-[12px] font-semibold uppercase tracking-wide text-[var(--black)]">{{ branch.address }}</span>
                  </div>
                  <span class="text-[10px] uppercase tracking-widest text-[var(--dark-grey)] group-hover:text-[var(--black)] transition-colors">
                    {{ expandedScheduleBranchId === branch.id ? ('schedule.hide' | translate) : ('schedule.viewHours' | translate) }}
                  </span>
                </button>
                <div *ngIf="expandedScheduleBranchId === branch.id" class="pb-4">
                  <app-branch-schedule [schedules]="branch.schedules || []" [branchAddress]="branch.address"></app-branch-schedule>
                </div>
                <div class="w-full h-px bg-[var(--grey)]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-[var(--black)]" *ngIf="!isLoadingEvents && events.length !== 0">
      <div class="mx-auto max-w-screen-desktop container-padding ">
        <h2 id="eventos" class="text-[var(--yellow)] uppercase mobile:text-[34px]/[84px] text-[28px]/[75px] font-normal text-center">{{ 'brewery.relatedEvents' | translate }}</h2>
      </div>
    </div>

    <app-events-showcase
      *ngIf="isLoadingEvents || events.length > 0"
      [events]="events"
      [isLoading]="isLoadingEvents"
      [showFilters]="false"
      [showTitle]="false"
      [compact]="true">
    </app-events-showcase>
  </div>
</div>